import gql from 'graphql-tag';

const BUDGET_ADJUST = gql`
  mutation budgetAdjust($params: AdjustBudgetRequest!) {
    budgetAdjust(params: $params) {
      budgetAdjustmentId
      request {
        budgetUuid
        insertionOrderRef
        amount
        budgetAdjustmentName
        approvalDate
      }
    }
  }
`;

export default BUDGET_ADJUST;
